import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function TransporteAnexo21y22RMF2026Certificado() {
  return <CategoryPage category="transporteAnexo21Y22Rmf2026Certificado2026" pageTitle="Certificado JSON 2026" />;
}

export default TransporteAnexo21y22RMF2026Certificado;
